<script>
export default {
  name: "SSO",
  data() {
    return {
      url: null
    };
  },
  mounted() {
    let url = new URL(process.env.VUE_APP_SSO_HOST);
    let data = {
      client_id: window.location.host.match(/^kz/)
        ? process.env.VUE_APP_SSO_CLIENT_ID_KZ
        : process.env.VUE_APP_SSO_CLIENT_ID_RU,
      redirect_uri: `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_SSO_REDIRECT_URL}`,
      clientapp: "amwaypersonalpages",
      response_type: "id_token",
      state: "WAHWBTaLbBetB}K0fpcgr$VGgVOA7$bJzquy73CE",
      nonce: "Bi58Q#VUywDFsu",
      scope: "openid partyID abo acct_subtype abo_name sponsor",
      amw_clientapp: "amwaypersonalpages"
    };
    url.search = new URLSearchParams(data);
    window.location.href = url.toString();
  }
};
</script>

<style scoped></style>
